import { Spin, App as AntApp } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import AppError from './AppError';
import AppMessage from './AppMessage';
import { Route, Routes } from 'react-router-dom';
import JobOrders from '../components/Pages/JobOrders';
import SignInPage from '../components/Pages/SignIn';
import { PrivateRoute } from '../modules/auth/containers';
import LogoutPage from '../components/Pages/Logout';
import CreateJobOrderPage from '../components/Pages/CreateJobOrder';
import JobOrderDetailPage from '../components/Pages/JobOrderDetail';
import ClientsPage from '../components/Pages/Clients';
import ClientPage from '../components/Pages/Client';
import DriversPage from '../components/Pages/Drivers';
import DriverPage from '../components/Pages/Driver';
import JobOrderPaymentPage from '../components/Pages/JobOrderPaymentPage';
import StripeAccountLinkRefreshPage from '../components/Pages/StripeAccountLinkRefresh';
import StripeAccountLinkReturnPage from '../components/Pages/StripeAccountLinkReturn';
import CompaniesPage from '../components/Pages/Companies';
import CompanyPage from '../components/Pages/Company';
import SettingsPage from '../components/Pages/Settings';
import PageNotFound from '../components/Pages/PageNotFound';

const App = () => {
  const globalLoading = useSelector((state) => state.common.globalLoading);
  return (
    <AntApp>
      <Spin spinning={globalLoading} wrapperClassName="wrap-spin">
        <AppError />
        <AppMessage />
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <JobOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/job-orders"
            element={
              <PrivateRoute>
                <JobOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/job-orders/create"
            element={
              <PrivateRoute>
                <CreateJobOrderPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/job-orders/:jobOrderId"
            element={
              <PrivateRoute>
                <JobOrderDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/job-orders/payment/:jobOrderId"
            element={
              <PrivateRoute>
                <JobOrderPaymentPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/drivers"
            element={
              <PrivateRoute>
                <DriversPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/drivers/create"
            element={
              <PrivateRoute>
                <DriverPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/drivers/:id"
            element={
              <PrivateRoute>
                <DriverPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <ClientsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/new"
            element={
              <PrivateRoute>
                <ClientPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/:id"
            element={
              <PrivateRoute>
                <ClientPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <PrivateRoute>
                <CompaniesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/companies/new"
            element={
              <PrivateRoute>
                <CompanyPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/companies/:id"
            element={
              <PrivateRoute>
                <CompanyPage />
              </PrivateRoute>
            }
          />
          <Route exact path="/logout" element={<LogoutPage />} />
          <Route path="/login" element={<SignInPage />} />
          <Route path="/stripe/account-link/refresh" element={<StripeAccountLinkRefreshPage />} />
          <Route path="/stripe/account-link/return" element={<StripeAccountLinkReturnPage />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </Spin>
    </AntApp>
  );
};

export default App;
